import React from 'react'

export default function NotFound() {
  return (
    <div>
      <h1>Pagina no Encontrada</h1>
    </div>
  )
}
